import { GetUserAppletLinksModel } from ".";

export type LayoutNodeObjTypes = "FOLDER" | "APPLET";

export interface IFileNodeBase {
  name: string;
  objType: LayoutNodeObjTypes;
  data: GetUserAppletLinksModel | null;
  children: IFileNodeBase[];
  propertyJson: any;
}

export interface IFileNode extends IFileNodeBase {
  selected: boolean;
  expanded: boolean;
  children: IFileNode[]
};